module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "p46"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rp46"
    }
  }, [_vm._v("LENTIL SOUP")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line-3.jpg",
      "width": "532"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('i', [_vm._v("This satisfying soup is good on a cold, snowy day.")])])]), _vm._v(" "), _c('p', {
    staticClass: "make"
  }, [_c('span', [_vm._v("6 first-course servings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 pound dry brown lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 cup finely chopped onion")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ cup each: finely chopped celery and carrot")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 quarts water")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("1 large smoked pork hock")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("2 teaspoons each: sugar, beef bouillon crystals")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("¼ teaspoon dry mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("½ teaspoon dried thyme leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', [_vm._v("Salt and cayenne pepper, to taste")])]), _vm._v(" "), _c('p', {
    staticClass: "normalt"
  }, [_c('span', [_c('b', [_vm._v("1.")]), _vm._v(" Heat all ingredients, except salt and pepper, to boiling in large saucepan; reduce heat and simmer, covered, until lentils are very tender and soup has thickened, about 45 minutes. Discard pork hock; skim fat from soup and season to taste with salt and pepper.")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Per Serving:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Calories: 89")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("% calories from fat: 12")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Protein (g): 6.7")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Carbohydrate (g): 16.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat (g): 1.4")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Saturated fat (g): 0.3")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Cholesterol (mg): 6.5")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Sodium (mg): 277")])]), _vm._v(" "), _c('p', {
    staticClass: "per"
  }, [_c('span', [_vm._v("Exchanges:")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Milk: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Vegetable: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fruit: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Bread: 1.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Meat: 0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "per1"
  }, [_c('span', [_vm._v("Fat: 0.5")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2492d1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter0227.vue
// module id = 216
// module chunks = 0